import AddIcon from '../assets/icons/add.svg?react';
import AlertIcon from '../assets/icons/alert.svg?react';
import ArrowDropDownIcon from '../assets/icons/arrow-drop-down.svg?react';
import ArrowDropUpIcon from '../assets/icons/arrow-drop-up.svg?react';
import BoltIcon from '../assets/icons/bolt.svg?react';
import BoltSlashIcon from '../assets/icons/bolt-slash.svg?react';
import CalendarIcon from '../assets/icons/calendar.svg?react';
import CameraPlusIcon from '../assets/icons/camera-plus.svg?react';
import ChartIcon from '../assets/icons/chart.svg?react';
import CheckIcon from '../assets/icons/check.svg?react';
import CheckCircleIcon from '../assets/icons/check-circle.svg?react';
import ChevronDownIcon from '../assets/icons/chevron-down.svg?react';
import ChevronLeftIcon from '../assets/icons/chevron-left.svg?react';
import ChevronRightIcon from '../assets/icons/chevron-right.svg?react';
import ChevronUpIcon from '../assets/icons/chevron-up.svg?react';
import CloseIcon from '../assets/icons/close.svg?react';
import DataCheckIcon from '../assets/icons/data-check.svg?react';
import DiagramIcon from '../assets/icons/diagram.svg?react';
import DraftIcon from '../assets/icons/draft.svg?react';
import EditIcon from '../assets/icons/edit.svg?react';
import EyeIcon from '../assets/icons/eye.svg?react';
import EyeOffIcon from '../assets/icons/eye-off.svg?react';
import FilledQuestionIcon from '../assets/icons/filled-question.svg?react';
import FileIcon from '../assets/icons/file.svg?react';
import HelmetGuyIcon from '../assets/icons/helmet-guy.svg?react';
import InfoIcon from '../assets/icons/info.svg?react';
import LeaderboardIcon from '../assets/icons/leaderboard.svg?react';
import ListsIcon from '../assets/icons/lists.svg?react';
import LogoIcon from '../assets/icons/logo.svg?react';
import PlusIcon from '../assets/icons/plus.svg?react';
import NewsIcon from '../assets/icons/news.svg?react';
import QRCodeIcon from '../assets/icons/qrcode.svg?react';
import QuestionIcon from '../assets/icons/question.svg?react';
import RulesIcon from '../assets/icons/rules.svg?react';
import SearchIcon from '../assets/icons/search.svg?react';
import SettingIcon from '../assets/icons/setting.svg?react';
import SortIcon from '../assets/icons/sort.svg?react';
import SpinnerIcon from '../assets/icons/spinner.svg?react';
import PaperStatisticsIcon from '../assets/icons/paper-statistics.svg?react';
import PenIcon from '../assets/icons/pen.svg?react';
import UploadIcon from '../assets/icons/upload.svg?react';
import UserCircleIcon from '../assets/icons/user-circle.svg?react';
import WarningIcon from '../assets/icons/warning.svg?react';
import ContractIcon from '../assets/icons/contract.svg?react';
import TrashIcon from '../assets/icons/trash.svg?react';
import LogoutIcon from '../assets/icons/logout.svg?react';
import ValidationIcon from '../assets/icons/validation.svg?react';
import DownloadIcon from '../assets/icons/download.svg?react';

export const IconType = {
  Add: AddIcon,
  Alert: AlertIcon,
  ArrowDropDown: ArrowDropDownIcon,
  ArrowDropUp: ArrowDropUpIcon,
  Bolt: BoltIcon,
  BoltSlash: BoltSlashIcon,
  Calendar: CalendarIcon,
  CameraPlus: CameraPlusIcon,
  Chart: ChartIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  ChevronDown: ChevronDownIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  ChevronUp: ChevronUpIcon,
  Close: CloseIcon,
  DataCheck: DataCheckIcon,
  Diagram: DiagramIcon,
  Draft: DraftIcon,
  Edit: EditIcon,
  Eye: EyeIcon,
  EyeOff: EyeOffIcon,
  FilledQuestion: FilledQuestionIcon,
  File: FileIcon,
  HelmetGuy: HelmetGuyIcon,
  Info: InfoIcon,
  Leaderboard: LeaderboardIcon,
  Lists: ListsIcon,
  Logo: LogoIcon,
  Plus: PlusIcon,
  News: NewsIcon,
  QRCode: QRCodeIcon,
  Question: QuestionIcon,
  Rules: RulesIcon,
  Search: SearchIcon,
  Setting: SettingIcon,
  Sort: SortIcon,
  Spinner: SpinnerIcon,
  PaperStatistics: PaperStatisticsIcon,
  Pen: PenIcon,
  Upload: UploadIcon,
  UserCircle: UserCircleIcon,
  Warning: WarningIcon,
  Contract: ContractIcon,
  Trash: TrashIcon,
  Logout: LogoutIcon,
  Validation: ValidationIcon,
  Download: DownloadIcon,
} as const;

export type IconName = keyof typeof IconType;
